import {Component, ElementRef, OnInit, Renderer2} from '@angular/core';
import {AppService} from '../../services/app.service';
import * as $ from 'jquery';
import {FormGroup, FormControl, Validators, FormBuilder} from '@angular/forms';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Router} from '@angular/router';
import UIkit from 'uikit';
import {UserService} from '../../services/user.service';
import {User} from '../../_models/user.model';
import {AuthenticationService} from '../../services/authentication.service';
import {Title} from '@angular/platform-browser';


@Component({
  selector: 'app-myaccount',
  templateUrl: './myaccount.component.html',
  styleUrls: ['./myaccount.component.css']
})
export class MyaccountComponent implements OnInit {

  public userProfile;
  profileForm: FormGroup;
  public responseAwaited;
  public responseReceived = false;
  public orders: any;
  public isFormFieldsDisabled = true;
  public cancellationPayLoad = {order_feedback: '', order_id: '', user_cancel_comment: ''};
  public selectedOrderForCancellation: any;
  public orderPaymentResponse: any;
  public product: any;
  public coupons: any;
  public pollHistory: any;

  // bucket list
  public bucketListProducts = {STANDARD: '', EXPERIENCE: ''};

  // profile update
  public profileUpdateResponseReceived = false;
  public errorMessage = '';
  public successMessage = '';
  public cancellationSuccessMessage = '';
  public cancellationErrorMessage = '';

  // device identification
  public deviceInfo;
  public isMobile;
  public isDesktopDevice;


  constructor(
    private appService: AppService,
    private fb: FormBuilder,
    private http: HttpClient,
    private renderer: Renderer2,
    private el: ElementRef,
    private router: Router,
    private userService: UserService,
    private authenticateService: AuthenticationService,
    private deviceService: DeviceDetectorService,
    private titleService: Title
  ) {

    // if not logged in logout to homepage
    this.authenticateService.currentUser.subscribe(x => {
      if (!x) {
        this.router.navigate(['/']);
      } else {
        this.currentUser = x;
      }
    });

    this.userProfile = this.currentUser;
    this.titleService.setTitle('Things2do - My Account');

    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isDesktopDevice = this.deviceService.isDesktop();

    // setup the form
    this.profileForm = this.fb.group({
      email: [{value: this.userProfile.email, disabled: this.isFormFieldsDisabled}, [Validators.required, Validators.email]],
      first_name: [{value: this.userProfile.first_name, disabled: this.isFormFieldsDisabled}, [Validators.required, Validators.max(255)]],
      last_name: [{value: this.userProfile.last_name, disabled: this.isFormFieldsDisabled}, [Validators.required, Validators.max(255)]],
      mobile_number: [{
        value: this.userProfile.mobile_number,
        disabled: this.isFormFieldsDisabled
      }, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      city: [{value: this.userProfile.city, disabled: this.isFormFieldsDisabled}, Validators.required],
      birthday: [{value: '', disabled: this.isFormFieldsDisabled}],
      marital_status: [{value: '', disabled: this.isFormFieldsDisabled}],
    });
  }

  currentUser: User;

  ngOnInit(): void {

    /*this.appService.userLoggedOut.subscribe(data => {
      this.router.navigate(['/']);
    });*/

    console.log('access token', this.appService.getAccessToken());
    if (!this.appService.getAccessToken()) {
      this.router.navigate(['/']);
      UIkit.modal('#modal-center').show();
    }

    this.getProfile();
    this.getOrders();
    // Todo: fetch the current profile and update the values in the form

    $('#MyBucket').hide();
    $('#MyOrder').hide();
    $('#MyProfile').hide();

    this.getBucketList();
    this.getBucketListPremium();
    if (this.isDesktopDevice) {
      this.showMyOrders();
    }

    this.getCoupons();
    this.getPollHistory();
  }

  /**
   * Clear session and logout from the system.
   */
  doLogout(): void {
    localStorage.removeItem('accessToken');
    this.authenticateService.logout();
    this.appService.triggerUserLoggedOut();
    this.router.navigate(['/']);
  }

  getProfile(): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json', Authorization: localStorage.getItem('accessToken')})
    };

    this.responseAwaited = true;

    this.http.get<any>(environment.domain + '/api/profile', httpOptions).subscribe(
      data => {
        this.responseReceived = true;
        if (data.type === 'success') {
          this.profileForm.controls.first_name.setValue(data.data.first_name);
          this.profileForm.controls.last_name.setValue(data.data.last_name);
          this.profileForm.controls.email.setValue(data.data.email);
          this.profileForm.controls.city.setValue(data.data.city);
          this.profileForm.controls.birthday.setValue(data.data.birthday);
          this.profileForm.controls.marital_status.setValue(data.data.marital_status);

        }
      },
      error => {
        console.error('There was an error!', error);
        console.error(error.error);
      });
  }

  getCoupons(): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json', Authorization: localStorage.getItem('accessToken')})
    };

    this.responseAwaited = true;

    this.http.get<any>(environment.domain + '/api/ipl/coupon', httpOptions).subscribe(
      data => {
        this.responseReceived = true;
        if (data.type === 'success') {
          this.coupons = data.data;
        }
      },
      error => {
        console.error('There was an error!', error);
        console.error(error.error);
      });
  }

  getPollHistory(): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json', Authorization: localStorage.getItem('accessToken')})
    };

    this.responseAwaited = true;

    this.http.get<any>(environment.domain + '/api/poll/history', httpOptions).subscribe(
      data => {
        this.responseReceived = true;
        if (data.type === 'success') {
          this.pollHistory = data.data;
        }
      },
      error => {
        console.error('There was an error!', error);
        console.error(error.error);
      });
  }

  getBucketList(): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json', Authorization: localStorage.getItem('accessToken')})
    };

    this.responseAwaited = true;

    this.http.get<any>(environment.domain + '/api/standard/wishlist', httpOptions).subscribe(
      data => {
        this.responseReceived = true;
        if (data.type === 'success') {
          this.bucketListProducts.STANDARD = data.data.data;
        }
      },
      error => {
        console.error('There was an error!', error);
        console.error(error.error);
      });
  }

  getBucketListPremium(): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json', Authorization: localStorage.getItem('accessToken')})
    };

    this.responseAwaited = true;

    this.http.get<any>(environment.domain + '/api/experience/wishlist', httpOptions).subscribe(
      data => {
        this.responseReceived = true;
        if (data.type === 'success') {
          this.bucketListProducts.EXPERIENCE = data.data.data;
        }
      },
      error => {
        console.error('There was an error!', error);
        console.error(error.error);
      });
  }

  /**
   * Get the user orders
   */
  getOrders(): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json', Authorization: localStorage.getItem('accessToken')})
    };

    this.responseAwaited = true;

    this.http.post<any>(environment.domain + '/api/orders-list', {}, httpOptions).subscribe(
      data => {
        this.responseReceived = true;
        if (data.type === 'success') {
          this.orders = data.orders;
        }
      },
      error => {
        console.error('There was an error!', error);
        console.error(error.error);
      });
  }

  /**
   * Save the user profile
   */
  saveProfile(): void {
    if (this.profileForm.valid) {
      this.responseAwaited = true;
      this.userService.update(this.profileForm.value).subscribe(
        data => {
          this.profileUpdateResponseReceived = true;
          if (data.type === 'error') {
            this.errorMessage = data.message;
          } else {
            this.successMessage = 'Your profile has been updated.';
          }
          this.responseAwaited = false;
        },
        error => {
          if (error.status == 422) {
            this.errorMessage = 'Email is already taken';
          }
          console.error('There was an error!', error);
          this.responseAwaited = false;
        });


    } else {
      // validate all form fields
      this.validateAllFormFields(this.profileForm);
    }
  }

  public onVideoIntersection({target, visible}: { target: any; visible: boolean }): void {

    if (!this.isMobile) {
      return;
    }

    this.renderer.addClass(target, visible ? 'active' : 'inactive');
    this.renderer.removeClass(target, visible ? 'inactive' : 'active');

    // this.renderer.setProperty(target, 'play', true);
    // target.nativeElement.play();
    if (visible) {
      target.play();
    } else {
      target.pause();
    }
  }

  /*** HELPERS **/
  validateAllFormFields(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  enableProfileEditing(e): void {

    const w = $(e).attr('src');
    (w === 'assets/images/icons/edit.png') ? $(e).attr('src', 'assets/images/icons/close-sm.png') : $(e).attr('src', 'assets/images/icons/edit.png');
    if (w === 'assets/images/icons/edit.png') {
      $(e).parents('.myprofile-form-wrp').find('.btn-yellow').show();
      // $(e).parents('.myprofile-form-wrp').find('.uk-input,.uk-select').prop('disabled', false);

      Object.keys(this.profileForm.controls).forEach((controlName) => {
        this.profileForm.controls[controlName].enable(); // disables/enables each form control based on 'this.formDisabled'
      });
    } else {
      $(e).parents('.myprofile-form-wrp').find('.btn-yellow').hide();
      // $(e).parents('.myprofile-form-wrp').find('.uk-input,.uk-select').prop('disabled', true);

      Object.keys(this.profileForm.controls).forEach((controlName) => {
        this.profileForm.controls[controlName].disable(); // disables/enables each form control based on 'this.formDisabled'
      });
    }
  }

  videoVolumeControl(e): void {
    let x = $(e).attr('src');
    (x == 'assets/images/icons/sound.png') ? $(e).attr('src', 'assets/images/icons/mute.png') : $(e).attr('src', 'assets/images/icons/sound.png');
    (x == 'assets/images/icons/sound.png') ? $(e).parents('.image').find('video').prop('muted', true) : $(e).parents('.image').find('video').prop('muted', false);
  }

  /**
   * Navigate to product page.
   * @param productID
   * @param product
   */
  showProductDetail(product): void {
    this.router.navigate(['c/' + product.details.city.toLowerCase().toString() + '/' + product.details.slug], {state: product});
  }

  playVideo(e): void {
    e.play();
  }

  pauseVideo(e): void {
    e.pause();
  }


  showMyProfile(): void {
    if (this.isDesktopDevice) {
      $('#MyProfile').fadeIn();
      $('#MyOrder').hide();
      $('#MyBucket').hide();
    } else {
      $('.myprofile-left-panel-wrp').hide();
      $('#MyProfile').fadeIn();
    }
  }

  showMyOrders(): void {
    if (this.isDesktopDevice) {
      $('#MyOrder').fadeIn();
      $('#MyProfile').hide();
      $('#MyBucket').hide();
    } else {
      $('.myprofile-left-panel-wrp').hide();
      $('#MyOrder').fadeIn();
    }
  }

  showMyBucketlist(): void {
    if (this.isDesktopDevice) {
      $('#MyBucket').fadeIn();
      $('#MyOrder').hide();
      $('#MyProfile').hide();
    } else {
      $('.myprofile-left-panel-wrp').hide();
      $('#MyBucket').fadeIn();
    }
  }

  goBacktoMyAccount(): void {

    if (this.isMobile) {
      $('#MyBucket').hide();
      $('#MyOrder').hide();
      $('#MyProfile').hide();
      $('#MyCoupons').hide();
      $('#MyPollHistory').hide();
      $('.myprofile-left-panel-wrp').show();
    }
    this.router.navigate(['/my-account']);
  }

  //29 March
  showMyCoupons(): void {
    if (this.isDesktopDevice) {
      $('#MyBucket').hide();
      $('#MyOrder').hide();
      $('#MyProfile').hide();
      $('#MyCoupons').fadeIn();
      $('#MyPollHistory').hide();
    } else {
      $('.myprofile-left-panel-wrp').hide();
      $('#MyCoupons').fadeIn();
    }
  }

  showMyPoll(): void {
    if (this.isDesktopDevice) {
      $('#MyBucket').hide();
      $('#MyOrder').hide();
      $('#MyProfile').hide();
      $('#MyCoupons').hide();
      $('#MyPollHistory').fadeIn();
    } else {
      $('.myprofile-left-panel-wrp').hide();
      $('#MyPollHistory').fadeIn();
    }
  }

  //End

  selectCancellationReason(e): void {
    this.cancellationPayLoad.user_cancel_comment = e.value;
  }

  showCancellationForm(order: any): void {

    this.cancellationPayLoad.user_cancel_comment = '';
    this.cancellationPayLoad.order_feedback = '';

    this.responseAwaited = false;
    this.selectedOrderForCancellation = order;
    this.cancellationPayLoad.order_id = order.order.order_id;

    UIkit.modal('#cancel-order').show();
  }

  cancelOrder(): boolean {

    console.log(this.cancellationPayLoad);
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json', Authorization: localStorage.getItem('accessToken')})
    };

    if (this.cancellationPayLoad.user_cancel_comment.length < 6) {
      this.cancellationErrorMessage = 'Please select cancellation reason.';
      return false;
    } else if (this.cancellationPayLoad.order_feedback.length < 4) {
      this.cancellationErrorMessage = 'Please enter your comments.';
      return false;
    }

    this.responseAwaited = true;

    this.http.post<any>(environment.domain + '/api/orders/cancel', this.cancellationPayLoad, httpOptions).subscribe(
      data => {

        if (data.type === 'error') {
          this.errorMessage = data.message;
        } else {
          this.cancellationSuccessMessage = 'Thank you, we will get in touch soon.';
          setTimeout(e => {
            UIkit.modal('#cancel-order').hide();
            this.getOrders();
          }, 2000);
        }

        this.responseAwaited = false;

      },
      error => {
        console.error('There was an error!', error);
        this.responseAwaited = false;
      });
  }

  showOrderSummary(order): void {
    this.product = order.product;
    this.orderPaymentResponse = order;
    UIkit.modal('#order-summary').show();
  }

}
